import { getMentiAcademyURL } from '@mentimeter/user';
import { trackUser } from '@api/tracking/client';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Button } from '@mentimeter/ragnar-ui/button';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Heading } from '@mentimeter/ragnar-ui/typography';
import { Image } from '@mentimeter/ragnar-ui/image';
import MentiAcademyPromo from '../assets/MentiAcademyPromo.webp';

export const MentiAcademy = ({ context }: { context: string }) => {
  const trackGoToAcademy = () => {
    trackUser({
      event: 'Clicked go to academy',
      properties: { context },
    });
  };

  return (
    <Box width="100%">
      <Box width="100%" mb={[3, 4]} mx="auto" maxWidth={600}>
        <Image
          alt="Mentimeter academy promo screenshots"
          title="Introducing the Mentimeter academy"
          src={MentiAcademyPromo.src}
        />
      </Box>
      <Heading as="h3">Get certified in Mentimeter</Heading>
      <Text>
        Our two brand new, self-paced courses are designed to help both
        educators and business professionals get the most out of the tool.
        Whether you’re teaching or presenting, we’ve got you covered. Just click
        the link below, and you’ll be automatically enrolled. And yes — you’ll
        get a certificate too!
      </Text>
      <Button
        size="large"
        mt={3}
        mb={2}
        variant="primary"
        target="_blank"
        rel="noopener noreferrer"
        onClick={trackGoToAcademy}
        href={getMentiAcademyURL(
          '/cart/add_product/1529975?price_id=1901688?utm_source=mentimeter.com&utm_medium=referral&utm_campaign=inapp_help',
        )}
      >
        Go to Academy
      </Button>
    </Box>
  );
};
